import dayjs from 'dayjs';
import type { TFunction } from 'i18next';

export const formatTimeAgo = (createdAt: string | null | undefined, t: TFunction) => {
  if (!createdAt) return '';

  const now = dayjs();
  const created = dayjs(createdAt);
  const diffInHours = now.diff(created, 'hour');

  if (diffInHours < 1) {
    return t('time.hoursAgo', { hours: '<1' });
  }

  if (diffInHours >= 24) {
    const diffInDays = Math.floor(diffInHours / 24);
    return t('time.daysAgo', { days: diffInDays });
  }

  return t('time.hoursAgo', { hours: diffInHours });
};
